<section class="mb-4">
  <div class="d-flex justify-content-end">
    <a class="btn btn-sm btn-nz-outline-primary flex-0 dropdown-toggle"
       role="button"
       aria-expanded="false"
       data-bs-toggle="dropdown">
      <i class="me-2 fa-solid fa-tools" aria-hidden="true"></i>
      Групови действия
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfileAdsGroupActionsModal('renewal-after-expired')">
          <i class="dropdown-item-icon text-muted fa-solid fa-arrows-rotate" aria-hidden="true"></i>
          Групово обновяване
        </button>
      </li>
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfileAdsGroupActionsModal('renewal-after-sold')">
          <i class="dropdown-item-icon text-muted fa-solid fa-clone" aria-hidden="true"></i>
          Групово копиране като нови
        </button>
      </li>
      <hr class="dropdown-divider">
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfileAdsGroupActionsModal('stop')">
          <i class="dropdown-item-icon text-warning fa-solid fa-ban" aria-hidden="true"></i>
          Групово спиране
        </button>
      </li>
      <li>
        <button class="dropdown-item"
                (click)="onOpenProfileAdsGroupActionsModal('delete')">
          <i class="dropdown-item-icon text-danger fa-solid fa-trash-can" aria-hidden="true"></i>
          Групово изтриване
        </button>
      </li>
    </ul>
  </div>
</section>
<section class="mb-4">
  <nz-search-input
    [searchValue]="searchValue"
    (onSearchValueChange)="onSearch($event)"
    placeholder="Търсене по заглавие...">
  </nz-search-input>
</section>
<section class="mb-4">
  <nz-search-filter
    (onClearFilters)="clearFilters()"
    [activeFiltersCount]="activeFiltersCount">
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <span class="form-label">Категория</span>
        <ng-select
          id="adCategoryId"
          [clearable]="false"
          [searchable]="false"
          [items]="adCategories"
          bindValue="adCategoryId"
          bindLabel="adCategoryName"
          notFoundText="Няма намерени категории"
          [ngModel]="selectedAdCategoryId"
          (ngModelChange)="onChangeAdCategoryId($event)"
          placeholder="Изберете категория">
          <ng-template ng-option-tmp let-item="item">
            <div>
              <div>{{ item.adCategoryName }}</div>
              <small class="mb-0 text-muted">{{ item.adCategoryDescription }}</small>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-12 col-md-6">
        <span class="form-label">Подкатегория*</span>
        <ng-select
          id="adSubcategoryId"
          [clearable]="false"
          [searchable]="false"
          [items]="filteredAdSubcategories"
          bindValue="adSubcategoryId"
          bindLabel="adSubcategoryName"
          [ngModel]="selectedAdSubcategoryId"
          [disabled]="selectedAdCategoryId === 0"
          (ngModelChange)="onChangeAdSubcategoryId($event)"
          notFoundText="Няма намерени подкатегории"
          placeholder="Изберете подкатегория">
        </ng-select>
      </div>
    </div>
    <hr/>
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <span class="mb-1 form-label">Статус</span>
        <div class="form-check">
          <input
            id="ad-status-all-ads"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdStatus($event)"
            [checked]="selectedAdStatus === 0"
            [value]="0">
          <label for="ad-status-all-ads" class="form-check-label">Всички обяви</label>
        </div>
        <div class="form-check">
          <input
            id="ad-status-active"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdStatus($event)"
            [checked]="selectedAdStatus === AdStatus.Active"
            [value]="AdStatus.Active">
          <label for="ad-status-active" class="form-check-label">Активни обяви</label>
        </div>
        <div class="form-check">
          <input
            id="ad-status-not-started"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdStatus($event)"
            [checked]="selectedAdStatus === AdStatus.NotStarted"
            [value]="AdStatus.NotStarted">
          <label for="ad-status-not-started" class="form-check-label">Обяви започващи скоро</label>
        </div>
        <div class="form-check">
          <input
            id="ad-status-completed-with-direct-sale"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdStatus($event)"
            [checked]="selectedAdStatus === AdStatus.CompletedWithDirectSale"
            [value]="AdStatus.CompletedWithDirectSale">
          <label for="ad-status-completed-with-direct-sale" class="form-check-label">Обяви завършили със сделка</label>
        </div>
        <div class="form-check">
          <input
            id="ad-status-completed-without-deal"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdStatus($event)"
            [checked]="selectedAdStatus === AdStatus.CompletedWithoutDeal"
            [value]="AdStatus.CompletedWithoutDeal">
          <label for="ad-status-completed-without-deal" class="form-check-label">Обяви завършили без сделка</label>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <span class="mb-1 form-label">Вид обява</span>
        <div class="form-check">
          <input
            id="ad-type-all-ads"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdType($event)"
            [checked]="selectedAdType === 0"
            [value]="0">
          <label for="ad-type-all-ads" class="form-check-label">Всички обяви</label>
        </div>
        <div class="form-check">
          <input
            id="ad-type-fixed-price"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdType($event)"
            [checked]="selectedAdType === AdType.DirectSale"
            [value]="AdType.DirectSale">
          <label for="ad-type-fixed-price" class="form-check-label">Обяви с фиксирана цена</label>
        </div>
        <div class="form-check">
          <input
            id="ad-type-auction"
            type="radio"
            class="form-check-input"
            (change)="onChangeAdType($event)"
            [checked]="selectedAdType === AdType.Auction"
            [value]="AdType.Auction">
          <label for="ad-type-auction" class="form-check-label">Обяви с наддаване (аукциони)</label>
        </div>
      </div>
    </div>
  </nz-search-filter>
</section>
<section class="mb-4">
  <nz-search-result
    [totalResults]="totalResults"
    [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption"
    (onSortOptionChange)="onSort($event)">
  </nz-search-result>
</section>
@if (!loading) {
  @if (ads.length === 0) {
    <h4 class="my-5 text-muted">
      Няма намерени обяви
    </h4>
  }
  <section>
    <ul class="list-unstyled" nzRestoreScrollPosition>
      @for (ad of ads; track ad.adId) {
        <li class="my-3 d-flex border shadow bg-white rounded-3">
          <a class="profile-card-image"
             [routerLink]="[appRoutes.root, appRoutes.ad, ad.adId]">
            <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + ad.adId"/>
          </a>
          <div class="profile-card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between">
              <div class="text-truncate">
                <a class="px-2 pb-0 btn btn-link d-block text-truncate text-decoration-none text-start"
                   [routerLink]="[appRoutes.root, appRoutes.ad, ad.adId]">
                  <i class="small text-secondary fa-solid "
                     [ngClass]="ad.adType === AdType.DirectSale ? 'fa-shopping-cart' : 'fa-gavel'">
                  </i>
                  {{ ad.adTitle }}
                </a>
                <div class="px-2 small text-muted">
                  Цена: <strong>{{ ad.adPrice.toFixed(2) }}</strong> лв.
                </div>
                <div class="px-2 pb-1 small text-muted d-flex gap-2 ">
                  <div>Харесвания: <span [class.fw-bold]="!!ad.likeCount">{{ ad.likeCount }}</span></div>
                  <div>Посещения: <span [class.fw-bold]="!!ad.visitCount">{{ ad.visitCount }}</span></div>
                </div>
                <div class="px-2">
                  @if (ad.adStatus == AdStatus.Active) {
                    <span class="py-0 px-2 alert alert-primary small rounded-1">Активна обява</span>
                  } @else if (ad.adStatus === AdStatus.NotStarted) {
                    <span class="py-0 px-2 alert alert-warning small rounded-1">Започва скоро</span>
                  } @else if (ad.adStatus === AdStatus.CompletedWithoutDeal) {
                    <span class="py-0 px-2 alert alert-secondary small rounded-1">Завършила без сделка</span>
                  } @else {
                    <span class="py-0 px-2 alert alert-success small rounded-1">Завършила със сделка</span>
                  }
                </div>
              </div>
              <div class="dropdown">
                <button type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        class="btn btn-light text-muted dropdown-button">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                  <li>
                    <a class="dropdown-item"
                       [routerLink]="[appRoutes.root, appRoutes.ad, ad.adId]">
                      <i class="dropdown-item-icon text-muted fa-solid fa-eye" aria-hidden="true"></i>
                      Преглед на обявата
                    </a>
                  </li>
                  @if (ad.actionPermissions.canEdit) {
                    <li>
                      <a class="dropdown-item"
                         [routerLink]="[appRoutes.root, appRoutes.adUpdate, ad.adId]">
                        <i class="dropdown-item-icon text-muted fa-solid fa-pen-to-square" aria-hidden="true"></i>
                        Редактиране на обявата
                      </a>
                    </li>
                  }
                  @if (ad.actionPermissions.canRenew) {
                    <li>
                      <button class="dropdown-item"
                              (click)="onOpenAdRenewalIndividualModal(ad, 'after-expired')">
                        <i class="dropdown-item-icon text-muted fa-solid fa-arrows-rotate" aria-hidden="true"></i>
                        Обновяване на обявата
                      </button>
                    </li>
                  }
                  @if (ad.actionPermissions.canCopyAsNew) {
                    <li>
                      <button class="dropdown-item"
                              (click)="onOpenAdRenewalIndividualModal(ad, 'after-sold')">
                        <i class="dropdown-item-icon text-muted fa-solid fa-arrow-up-right-from-square"
                           aria-hidden="true"></i>
                        Копиране като нова обява
                      </button>
                    </li>
                  }
                  @if (ad.actionPermissions.canCreateSimilar) {
                    <li>
                      <a class="dropdown-item"
                         [routerLink]="[appRoutes.root, appRoutes.adCrateSimilar, ad.adId]">
                        <i class="dropdown-item-icon text-muted fa-solid fa-copy" aria-hidden="true"></i>
                        Добавяне на подобна обява
                      </a>
                    </li>
                  }
                  @if (ad.actionPermissions.canDelete || ad.actionPermissions.canStop) {
                    <hr class="dropdown-divider">
                  }
                  @if (ad.actionPermissions.canStop) {
                    <li>
                      <button class="dropdown-item"
                              [disabled]="loading"
                              (click)="showStopAdWarning(ad)">
                        <i class="dropdown-item-icon text-warning fa-solid fa-ban" aria-hidden="true"></i>
                        Спиране на обявата
                      </button>
                    </li>
                  }
                  @if (ad.actionPermissions.canDelete) {
                    <li>
                      <button class="dropdown-item"
                              (click)="showDeleteAdWarning(ad)">
                        <i class="dropdown-item-icon text-danger fa-solid fa-trash-can" aria-hidden="true"></i>
                        Изтриване на обявата
                      </button>
                    </li>
                  }
                </ul>
              </div>
            </div>
            <small class="p-2 pt-0 text-end text-muted">
              {{ ad.dateTime | date: 'dd:MM:yyyy г. HH:mm ч.' }}
            </small>
          </div>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
@if (this.totalResults > defaultPageLimit) {
  <section class="py-4">
    <nz-pagination
      [totalResults]="totalResults"
      [selectedPage]="selectedPage"
      [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
  </section>
}
